import { createFileRoute } from '@tanstack/react-router'
import TokenConfigurations from 'Integration/components/webhooks/tokenConfiguration/TokenConfigurations'

export const Route = createFileRoute('/integrations/_webhooks/webhook/token-configurations')({
    component: TokenConfigurations,
})
